import SearchBox from './search-box';

window.WartsilaSearchBox = SearchBox;